import React from "react"
import { logTool, randomInt, css } from "@jsUtils"
import { GridLines, ContentRow } from "@shared"

import TechSpecItem from "./TechSpecItem"

import Styles from "./techSpecs.module.scss"

const log = logTool(false)

/**
 * Handle a list of tech specs (tech specs pages proper)
 * List all tech specs out
 * @param {object} props - react props
 * @param {array} props.items - array of tech spec items
 * @param {boolean} props.hasGrid - turn the page gridlines on or off
 */
const TechSpecsList = props => {
  const { items, hasGrid } = props

  log("Tech Specs List:", props)

  return (
    <section className={Styles.techSpecList}>
      {hasGrid && <GridLines />}
      <ContentRow
        gridName="quarterAuto"
        extraClass={css(Styles.listWrapper, `techSpecListWrapperIEOverride`)}
      >
        {items.map(i => {
          // could not use the same id when all the items were the same, during testing
          const key = randomInt(0, Date.now())
          log("... specs list item", { key, item: i })

          return (
            <TechSpecItem
              title={i.title}
              titleClass={css(Styles.techLabel)}
              extraTitleWrapper={Styles.titleWrapper}
              content={i.html}
              contentClass={css(Styles.copy, `techSpecListeItemIEOverride`)}
              extraContentWrapper={Styles.contentWrapper}
              key={key}
              id={key}
            />
          )
        })}
      </ContentRow>
    </section>
  )
}

export default TechSpecsList
